import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Migrate from "../assets/images/migrate.png";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContextProvider";
import { useQuery } from "@tanstack/react-query";
import MigrateModal from "./MigrateModal";
import PayloftLogo from "../assets/images/payloft-logo.png";

const SettingsNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, user, setIsModalOpen, isModalOpen, globalProfile } =
    useAuth();
  const [isOpen, setIsOpen] = useState(false); // State to manage sidebar visibility
  const inactiveClass = "flex items-center py-2 px-5 gap-3 text-gray-400";
  const activeClass = "flex items-center py-2 px-5 gap-3 text-primary relative";
  const permissions = user.permissionList;

  const links = [
    {
      to: "/settings/business",
      name: "business",
      text: "Business",
      permission: "Update Business",
    },
    // {
    //   to: "/settings/settlement",
    //   name: "settlement",
    //   text: "Settlement",
    //   permission: "Add Settlement Account",
    // },
    {
      to: "/settings/permission",
      name: "permission",
      text: "Permission",
      permission: "Create Role",
    },
    {
      to: "/settings/api-keys",
      name: "api-keys",
      text: "API Keys",
      permission: "Get Credentials",
    },
  ];

  const filteredLinks = links.filter((link) =>
    permissions.includes(link.permission)
  );

  useEffect(() => {
    if (location.pathname === "/settings") {
      navigate("/settings/profile");
    }
  }, [location.pathname, navigate]);

  return (
    <div className="bg-arena-background md:h-full font-LT">
      <div className="flex">
        {/* Sidebar */}
        <div
          className={`bg-white h-screen md:min-h-[1200px] pt-4 lg:w-[20%] xl:w-[13%] w-[267px] z-50 flex flex-col justify-between ${isOpen ? "translate-x-0" : "-translate-x-full"
            } md:translate-x-0 fixed md:relative left-0 top-0 bottom-0 overflow-y-auto md:overflow-y-visible`}
        >
          <div className="flex flex-col items-center">
            <img
              src={window.__TENANT__?.logo ?? PayloftLogo}
              alt="logo"
              className="w-[92px] h-auto"
            />
            <div className="w-[191.98px]">
              <NavLink className="flex items-center gap-3" to="/dashboard">
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.4">
                      <path
                        d="M2.35 12.35L5.14 15.14C5.46 15.46 6 15.24 6 14.79L6 13L20 13C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11L6 11L6 9.20997C6 8.75997 5.46 8.53997 5.15 8.85997L2.36 11.65C2.16 11.84 2.16 12.16 2.35 12.35Z"
                        fill="#030229"
                      />
                    </g>
                  </svg>
                </span>
                <p className="text-gray-400 text-[12px] font-semibold">
                  Main Menu
                </p>
              </NavLink>
              <p className="text-primary text-base font-semibold mt-4 px-2">
                Settings
              </p>

              <div className="">
                <NavLink
                  to="/settings/profile"
                  className={
                    location.pathname === "/settings/profile" ||
                      location.pathname.includes("/settings/profile")
                      ? activeClass
                      : inactiveClass
                  }
                >
                  <p className="text-base font-semibold">Profile</p>
                  {location.pathname === "/settings/profile" ||
                    location.pathname.includes("/settings/profile") ? (
                    <div className="absolute top-1/2 left-[65%] transform -translate-y-1/2 w-12 h-px bg-primary"></div>
                  ) : null}
                </NavLink>
                {filteredLinks.map((link, index) => (
                  <NavLink
                    key={index}
                    to={link.to}
                    className={
                      location.pathname === link.to ||
                        location.pathname.includes(link.to)
                        ? activeClass
                        : inactiveClass
                    }
                  >
                    <p className="text-base font-semibold">{link.text}</p>
                    {location.pathname === link.to ||
                      location.pathname.includes(link.to) ? (
                      <div className="absolute top-1/2 left-[65%] transform -translate-y-1/2 w-12 h-px bg-primary"></div>
                    ) : null}
                  </NavLink>
                ))}
              </div>

              {user.migrated === true ||
                globalProfile === "PRODUCTION" ? null : (
                <div className="border-t pt-6">
                  <NavLink
                    className="flex py-3 px-5 gap-3"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <img src={Migrate} alt="migrate" className="w-6 h-6" />
                    <p className="text-gray-400 text-base font-bold">
                      Migrate to Production
                    </p>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Overlay for mobile view */}
        {isOpen && (
          <div
            className="bg-black opacity-50 absolute min-h-[100rem] w-full inset-0 z-40"
            onClick={() => setIsOpen(false)}
          ></div>
        )}

        {/* Toggle button for sidebar */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-700 text-2xl rounded-md"
          >
            {!isOpen ? "☰" : "✕"}
          </button>
        </div>

        {/* Main Content */}
        <div className="w-full md:overflow-hidden lg:w-[80%] xl:w-[87%] pt-4 md:p-5">
          <Outlet />
        </div>
      </div>
      {isModalOpen && <MigrateModal />}
    </div>
  );
};

export default SettingsNav;
